$(function () {
	$('.icon.icon--close-small').on('click', function () {
		$('.search-page__input').val('');
	})
});
